import { hWebCrossUpperLeft, hWebCrossUpperLeft2, hWebCrossUpperRight } from '../lace/hWebCross'
import { laceOfNetWebDouble5, laceOfVerticalPartsLeft } from './netWeb'
import { laceOfVerticalPartsRight, laceParts0, laceParts1, laceParts2, laceParts3, laceParts4, laceParts5 } from './parts/laceParts'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'

export const wi10Web = (ctx: CanvasRenderingContext2D, webColor: string, edgeColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'

  // 左半分レース
  laceParts2(ctx, laceColor, -10, -5) // 上1
  laceParts2(ctx, laceColor, -15, 10) // 上2
  laceParts2(ctx, laceColor, -20, 15) // 上3
  laceParts1(ctx, laceColor, -5, 0) // 上2

  //   // 右半分レース
  // laceここから
  laceParts0(ctx, laceColor, -5, -17) // ウェブ縦左上
  laceParts0(ctx, laceColor, 2, 5) // ウェブ縦左上
  laceParts2(ctx, laceColor, 10, 23)
  laceParts3(ctx, laceColor, -3, -8) // 上2
  laceParts3(ctx, laceColor, -12, -36) // 上1
  laceParts4(ctx, laceColor, -6, -30) // 上1
  laceParts4(ctx, laceColor, -3, -10) // 上2
  laceParts5(ctx, laceColor, -8, -30) // 上1
  laceParts5(ctx, laceColor, 0, -4) // 上2

  laceParts4(ctx, laceColor, -1, -52) // 上0

  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  hWebCrossUpperLeft2(ctx, laceColor, -3, 3) // クロス部分の左
  // ウェブ横2
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
  // ウェブ縦
  ctx.beginPath()
  ctx.moveTo(240, 233) // 左＿上
  ctx.quadraticCurveTo(254, 267, 254, 267) // 左＿下
  ctx.quadraticCurveTo(265, 243, 293, 208) // 右＿下
  ctx.quadraticCurveTo(283, 168, 283, 168) // 右＿上
  ctx.quadraticCurveTo(254, 199, 240, 233) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // レース
  laceOfNetWebDouble5(ctx, laceColor, -15, 15)
  laceOfNetWebDouble5(ctx, laceColor, -10, 30)

  // ヘリ革＿左
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(241, 233) // 左＿上
  ctx.quadraticCurveTo(255, 267, 255, 267) // 左＿下
  ctx.quadraticCurveTo(260, 256, 260, 256) // 右＿下
  ctx.quadraticCurveTo(245, 220, 245, 220) // 右＿上
  ctx.quadraticCurveTo(241, 233, 241, 233) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // // ヘリ革＿右
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(275, 176) // 左＿上
  ctx.quadraticCurveTo(286, 218, 286, 218) // 左＿下
  ctx.quadraticCurveTo(293, 208, 293, 208) // 右＿下
  ctx.quadraticCurveTo(283, 168, 283, 168) // 右＿上
  ctx.quadraticCurveTo(275, 176, 275, 176) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ウェブ横1(先端)
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 縦＿左
  ctx.moveTo(248, 222) // 上
  ctx.quadraticCurveTo(261, 253, 261, 253) // 下
  // 縦＿右
  ctx.moveTo(274, 181) // 上
  ctx.quadraticCurveTo(283, 217, 283, 217) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // レース
  laceOfVerticalPartsLeft(ctx, laceColor, -15, 10)
  laceOfVerticalPartsLeft(ctx, laceColor, -10, 19)
  // 縦パーツ右
  laceOfVerticalPartsRight(ctx, laceColor, -18, -14)
  laceOfVerticalPartsRight(ctx, laceColor, -14, 0)
}
